module.exports = __webpack_public_path__ + "img/ill_badge_print_lebel_pending.be549fad.svg";